import { css } from 'styled-components';

export const themeTokens = {
  checkoutTemplate: {
    wrapper: css``,
  },
  errorInputV2: {
    defaultStyle: css``,
  },
  inputV2: {
    defaultStyle: css``,
    inputErrorStyle: css``,
  },
  inputBoxV2: {
    defaultStyle: css``,
    inputBoxErrorStyle: css``,
    adyenStyle: css``,
  },
  labelInputV2: {
    defaultStyle: css``,
    labelInputErrorStyle: css``,
  },
  spacing: {
    none: 0,
    tiny: 8,
    small: 16,
    moderate: 24,
    medium: 32,
    large: 40,
    xlarge: 80,
  },
  button: {
    defaultStyle: css``,
  },
  inputBox: {
    defaultStyle: css``,
    inputBoxErrorStyle: css``,
  },
  input: {
    defaultStyle: css``,
    inputErrorStyle: css``,
  },
  labelInput: {
    defaultStyle: css``,
    labelInputErrorStyle: css``,
  },
  errorInput: {
    defaultStyle: css``,
  },
  joinVipAnnual: {
    shared: {
      styledText: css``,
      learnMoreLink: css``,
    },
  },
  basketItemPrice: {
    basketPrice: css``,
    priceLabel: css``,
  },
  basketItemDetails: {
    basketPricePromo: css``,
  },
  basketItem: {
    productName: css``,
  },
  basicModal: {
    dialogStyle: css``,
  },
  productDetailName: {
    productName: css``,
  },
  productDetailHeader: {
    promoTextWrapper: css``,
  },
  productDetailSizeSelector: {
    sizeCategoryLabel: css``,
  },
  colorSwatch: {
    colorTitle: css``,
  },
  quickViewModal: {
    updateButton: css``,
    styledLink: css``,
  },
  selectV2: {
    errorStyle: css``,
    errorHintStyle: css``,
    listStyle: css``,
    itemStyle: css``,
    buttonStyle: css``,
    labelStyle: css``,
    wrapperStyle: css``,
    quizStyle: css``,
    defaultStyle: css``,
  },
};
